import { ArrowLeft, Check, Eye, EyeOff, KeyRound } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Logo } from "../components/Logo";
import { apiRequest, ApiError } from "../lib/api";

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (password !== confirmation) return setError("Las contraseñas no coinciden");
    setBusy(true);
    setError("");
    try {
      await apiRequest("/auth/reset-password", { method: "POST", body: JSON.stringify({ token, password }) });
      navigate("/login?reset=success", { replace: true });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : "No pudimos actualizar la contraseña");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-top"><Link to="/login" className="icon-link"><ArrowLeft size={20} /></Link><Logo compact /></div>
      <div className="auth-card">
        <div className="auth-heading"><span className="step-label">Nueva contraseña</span><h1>Protegé tu cuenta</h1><p>Elegí una contraseña nueva de al menos 10 caracteres.</p></div>
        {!token ? <div className="form-error">El enlace está incompleto. Solicitá uno nuevo.</div> : (
          <form onSubmit={submit} className="form-stack">
            <label>Nueva contraseña<div className="password-field"><input type={visible ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" minLength={10} maxLength={128} required /><button type="button" onClick={() => setVisible((value) => !value)} aria-label="Mostrar contraseña">{visible ? <EyeOff size={19} /> : <Eye size={19} />}</button></div></label>
            <div className={password.length >= 10 ? "password-hint valid" : "password-hint"}><Check size={15} /> Al menos 10 caracteres</div>
            <label>Repetí la contraseña<input type={visible ? "text" : "password"} value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="new-password" minLength={10} maxLength={128} required /></label>
            {error && <div className="form-error" role="alert">{error}</div>}
            <button className="button primary large" disabled={busy || password.length < 10}>{busy ? "Guardando…" : <><KeyRound size={18} /> Cambiar contraseña</>}</button>
          </form>
        )}
      </div>
    </div>
  );
}
